// i18next-extract-mark-ns-start not-found

import * as React from 'react'
import { Link, useTranslation } from 'gatsby-plugin-react-i18next'
import Layout from 'src/components/layout'
import Helmet from 'react-helmet'
import Section from 'src/components/typography/Section'
import P from 'src/components/typography/Paragraph'
import ContentPageContainer from 'src/components/layout/ContentPageContainer'
import Article from 'src/components/typography/Article'
import SemiRoundedButton, {
  ButtonSizes,
} from 'src/components/ui/SemiRoundedButton'
import { graphql } from 'gatsby'
import PageTitleWrapper from 'src/components/typography/PageTitleWrapper'

const NotFoundPage = ({ data }) => {
  const { t } = useTranslation('not-found')
  const titleLine1 = t('Page')
  const titleLine2 = t('Not Found')
  return (
    <>
      <Helmet>
        <title>The IFAB - Page not found</title>
      </Helmet>
      <Layout pdfByCategoryPath={data.pdf.pdfByCategory?.path} pdfAzPath={data.pdf.pdfAZ?.path}>
        <PageTitleWrapper
          pageTitleData={{
            pageTitleLine1: titleLine1,
            pageTitleLine2: titleLine2,
            pageTitleLine2Margin: 1,
            mobilePageTitleLine1: titleLine1,
            mobilePageTitleLine2: titleLine2,
            mobilePageTitleLine2Margin: 1,
          }} 
          className="md:container mb-12"
        />
        <ContentPageContainer className="min-h-screen">
          <Article>
            <Section>
              <>
                <P className="text-center">
                  {t('Sorry, the page you requested cannot be found.')}
                </P>
                <div className="text-center mt-24">
                  <SemiRoundedButton size={ButtonSizes.medium}>
                    <Link to="/">{t('Back to home')}</Link>
                  </SemiRoundedButton>
                </div>
              </>
            </Section>
          </Article>
        </ContentPageContainer>
      </Layout>
    </>
  )
}

export const query = graphql`
  query($language: String!) {
    locales: allLocale(filter: { language: { eq: $language } }) {
      edges {
        node {
          ns
          data
          language
        }
      }
    }
    pdf: datoCmsFootballrulesPdfsDownload(locale: {eq: $language}) {
      pdfAZ {
        path
      }
      pdfByCategory {
        path
      }
    }
  }
`

export default NotFoundPage
